<template>
    <div class="legal-page">
      <header class="legal-header">
        <h1>{{ $t('termsOfServicePage.title') }}</h1>
      </header>
      <section class="legal-content">
        <div class="legal-section">
          <h2>{{ $t('termsOfServicePage.introTitle') }}</h2>
          <p>{{ $t('termsOfServicePage.introText') }}</p>
          <h2>{{ $t('termsOfServicePage.acceptanceTitle') }}</h2>
          <p>{{ $t('termsOfServicePage.acceptanceText') }}</p>
          <h2>{{ $t('termsOfServicePage.usageTitle') }}</h2>
          <p>{{ $t('termsOfServicePage.usageText') }}</p>
          <h2>{{ $t('termsOfServicePage.terminationTitle') }}</h2>
          <p>{{ $t('termsOfServicePage.terminationText') }}</p>
          <h2>{{ $t('termsOfServicePage.limitationTitle') }}</h2>
          <p>{{ $t('termsOfServicePage.limitationText') }}</p>
          <h2>{{ $t('termsOfServicePage.governingLawTitle') }}</h2>
          <p>{{ $t('termsOfServicePage.governingLawText') }}</p>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: "TermsOfServicePage",
  };
  </script>
  
  <style scoped>
  .legal-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #111;
    padding: 20px;
    color: #fff;
  }
  
  .legal-header {
    margin-bottom: 20px;
  }
  
  .legal-header h1 {
    font-size: 2.5em;
    color: #fff;
    text-align: center;
  }
  
  .legal-content {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .legal-section {
    background-color: #222;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }
  
  .legal-section h2 {
    font-size: 1.8em;
    color: #c00;
    margin-bottom: 10px;
  }
  
  .legal-section p {
    font-size: 1em;
    color: #ccc;
    line-height: 1.6;
  }
  </style>
  